import { Component, OnInit } from '@angular/core';

import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [ForgotPasswordService]
})
export class ForgotPasswordComponent implements OnInit {

  email:string = '';
  errorMessage:string = '';
  successMessage:string = '';

  constructor(private fpService:ForgotPasswordService) { }

  ngOnInit() {
    
  }

  onSubmit(){
     if (this.email == ''){
        return;
     }

     this.fpService.send(this.email).subscribe(
        res => this.forgotPasswordSuccess(res),
        error => this.loginError(error),
        () => console.log('Forgot Password Finished')
     );
  }

  forgotPasswordSuccess(response) {
    this.errorMessage = '';
    this.successMessage = `If the email you specified exists in our system, we've sent a password reset link to it.`;
  }

  private loginError(response:any){
    this.successMessage = '';
    
    try {
      let body = JSON.parse(response._body);
      this.errorMessage = body.modelState['model.Email'][0];
    } catch(e){
      this.errorMessage = 'An error has occurred.';
    }
  }
}


// {"message":"The request is invalid.","modelState":{"model.Email":["The Email field is not a valid e-mail address."]}}


// WEBPACK FOOTER //
// ./src/app/login/forgot-password/forgot-password.component.ts